import SpinViewer from '@components/360Spin/_SpinViewer';
import SpinIndicator from '@components/360Spin/_SpinIndicator';
import { useEffect, useState } from 'react';
import { ModalID } from '@repo/ui/src/modules/UI';
import { useUI } from '@repo/ui/src/modules/UI/hooks/useUI';
import axios from 'axios';
import { classNames } from '@repo/ui/src/utils/classNames';
import { useProductContext } from '@context/ProductProvider';

interface Props {
  dark?: boolean;
  encodedSpinSetUrl: string;
}

const SpinSetWrapper = ({ encodedSpinSetUrl, dark }: Props) => {
  const { mainProduct: product } = useProductContext();
  const [spinSetCount, setSpinSetCount] = useState(0);
  const { pushModal } = useUI();

  const productTitle = product?.title || 'Product 360 spin set';

  useEffect(() => {
    const { CancelToken } = axios;
    const source = CancelToken.source();
    const fetchMetadata = async () => {
      try {
        const res = await axios.get(`${encodedSpinSetUrl}.json`, {
          cancelToken: source.token,
        });
        if (res?.data?.items?.length) {
          setSpinSetCount(res.data.items.length);
        }
      } catch {
        // Do nothing - just don't show the spin set
      }
    };
    fetchMetadata();
    return () => {
      source.cancel();
    };
  }, [encodedSpinSetUrl]);

  return (
    <div className="relative w-full h-full flex flex-col items-center-justify-center">
      <div
        className={classNames(
          'spin-wrapper grid-row-start-1 grid-col-start-1 h-full relative z-20 transition-opacity duration-300 transition-linear [&_img]:object-contain [&_img]:h-full [&_img]:p-10 opacity-1',
        )}
      >
        <SpinViewer
          url={encodedSpinSetUrl}
          count={spinSetCount}
          ariaLabel={productTitle}
          disableMobilePointerEvents
        >
          <div className="grid grid-flow-col items-center justify-center gap-6 z-20">
            <SpinIndicator
              dark={dark}
              onClick={() =>
                pushModal(ModalID.threeSixtySpinViewer, {
                  url: encodedSpinSetUrl,
                  spinSetCount,
                  ariaLabel: productTitle,
                })
              }
            />
          </div>
        </SpinViewer>
      </div>
    </div>
  );
};

export default SpinSetWrapper;
